export function getIconForLowResImage(canvas: fabric.Canvas, activeObject: fabric.Object): fabric.Object | undefined {
  return canvas.getObjects().find((object) => object.data?.parentName === activeObject.name);
}
